import {
	FETCH_REFERRERS,
	FETCH_REFERRERS_SUCCESS,
	FETCH_REFERRERS_FAILURE,
	APPROVE_REFERRER,
	APPROVE_REFERRER_SUCCESS,
	APPROVE_REFERRER_FAILURE,
	DEACTIVATE_REFERRER,
	DEACTIVATE_REFERRER_SUCCESS,
	DEACTIVATE_REFERRER_FAILURE,
} from './constants';

export function fetchReferrers(params) {
	return {
		type: FETCH_REFERRERS,
		params,
	};
}

export function fetchReferrersSuccess(data) {
	return {
		type: FETCH_REFERRERS_SUCCESS,
		data,
	};
}

export function fetchReferrersFailure(error) {
	return {
		type: FETCH_REFERRERS_FAILURE,
		error,
	};
}

export function approveReferrer(id) {
	return {
		type: APPROVE_REFERRER,
		id,
	};
}

export function approveReferrerSuccess() {
	return {
		type: APPROVE_REFERRER_SUCCESS,
	};
}

export function approveReferrerFailure(error) {
	return {
		type: APPROVE_REFERRER_FAILURE,
		error,
	};
}

export function deactivateReferrer(id) {
	return {
		type: DEACTIVATE_REFERRER,
		id,
	};
}

export function deactivateReferrerSuccess() {
	return {
		type: DEACTIVATE_REFERRER_SUCCESS,
	};
}

export function deactivateReferrerFailure(error) {
	return {
		type: DEACTIVATE_REFERRER_FAILURE,
		error,
	};
}
